
export const NOTIFICATION_USER_HR_ID = 2
export const NOTIFICATION_USER_EMPLOYEE_ID = 1



// WEBPACK FOOTER //
// ./src/constants/userTypeNotification.js